import React, { memo } from 'react'

import { Button, ChevronDown, Icon, Paint } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { iconSize } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

const paintIcon = <Icon svgComponent={Paint} size={iconSize} notSpaced />
const chevronIcon = <Icon svgComponent={ChevronDown} size={iconSize} notSpaced />

// Placeholder trigger: the Style modal it will open is built in a separate task.
function StyleButton() {
  const t = useTranslation()

  return (
    <Button
      type="secondary"
      size="small"
      variant="with-icon"
      actionType="button"
      icon={paintIcon}
      trailIcon={chevronIcon}
      customClass="style-button cgt-button-text-base-semibold"
    >
      {t('imageAssistantPanel.createTab.composer.style')}
    </Button>
  )
}

export default memo(StyleButton)
